import * as Output from "../../Text";
import {FunctionalRules} from "../index";
import validateIban from "../../services/api/iban/iban";
import validatePhone from "../../services/api/mobilePhone";
const merge = (...rules) => v => rules.map(r => r(v)).find(v => !!v) ||
    undefined;

const conditional = (condition, validate) => (value, values) => condition(value, values) ? validate(value, values) : undefined;


const Rules = {
  none: v => undefined,
  required: v => (v && v.length > 0
      ? undefined
      : Output.resolve(
          'generic.errors.M001_mandatoryFields',
      )),
  maxLength: length => v => (!v || v.length <= length
      ? undefined
      : Output.resolve(
          'generic.errors.M003a_maxNumberOfCharacters',
      )),
  minLength: length => v => (!v || v.length >= length
      ? undefined
      : Output.resolve(
          'generic.errors.M003b_minNumberOfCharacters',
      )),
  integer: v => (!v || /^\d*$/.test(v)
      ? undefined
      : Output.resolve(
          'generic.errors.M002_invalidCharacters')),
  decimal: v => (!v || /^[0-9](\.[0-9]+)?/.test(v)
      ? undefined
      : Output.resolve(
          'generic.errors.M002_invalidCharacters',
      ))
};

const select = (...fieldNames) => (values, previousState = {}) => fieldNames.reduce(
    (errors, fieldName) => {
      try {
        const value = values[fieldName];
        const previousValue = previousState?.values?.[fieldName]
        const validate = FunctionalRules[fieldName];

        if (fieldName === "iban") {   
          const error = validate(value, values); 
          if (error){
            values["bic"] = '';
            values["bankName"] = '';
          }
          return error ? {...errors, iban : error}: validateIban(value)
          .then(response=>{
            if (!response.data.isValid){
              values["bic"] = '';
              values["bankName"] = '';
              errors["iban"] = Output.resolve('generic.errors.M007_ValidIBAN');
            } else {
              values["bic"] = response.data.paymentData.bic;
              values["bankName"] = response.data.paymentData.bankName;
            }
            return errors
           })
        } else if (fieldName === "mobilePhoneNumber") {   
          const error = validate(value, values);
          if (value !== previousValue) {
            return error ? {...errors, mobilePhoneNumber : error}: validatePhone(value, values.mobilePhoneCountryCode)
              .then(response=>{
                if (!response.data.isValid){
                  errors["mobilePhoneNumber"] = Output.resolve("generic.errors.M015_ServerValidPhoneNumber");
                } 
                return errors;
              })
          } else {
            return previousState?.errors?.mobilePhoneNumber
              ? { ...errors, mobilePhoneNumber: previousState.errors?.mobilePhoneNumber }
              : error
                ? { ...errors, mobilePhoneNumber: error }
                : errors
          }
        }
        
        else {
        if (!validate) {
          console.error(new Error(`No validation found for '${fieldName}'`));
          return errors;
        }

        const error = validate(value, values);

        if (error) {
          errors[fieldName] = error;
        }

        return errors;
      }
      } catch (err) {
        console.error(err);
        throw err;
      }
    }, {});


export {Rules, conditional, merge, select};